import './AnonymousAction.sass'
import { observer, inject } from 'mobx-react'
import React from 'react'
import SidePanel from '@root/Auth/Views/SidePanel'
import Logo from '@root/Auth/Views/SidePanel/logo.js'
import PropTypes from 'prop-types'

import { Formik, Form, Field } from 'formik'
import Button from '@components/Button'
import TextArea from '@components/Form/TextArea'
import { Dropdown } from '@components/Form/Autocomplete'
import Loading from '@components/spinner'
import TempResponsiveScreen from '@components/TempResponsiveScreen'
import ThankYou from '@components/TempResponsiveScreen/ThankYou'

const initialState = {
  screen: null,
  loading: false,
  error: false
}

class AnonymousAction extends TempResponsiveScreen {
  static propTypes = {
    complianceStore: PropTypes.object,
  }

  constructor(props) {
    super(props)
    this.submitForm = this.submitForm.bind(this)
    this.setScreen = this.setScreen.bind(this)
    this.setThankYouScreen = this.setThankYouScreen.bind(this)
    this.setSelectedTrustee = this.setSelectedTrustee.bind(this)

    const trustees = parseTrusteesFromEnvVar(process.env.REACT_APP_ANONACTION_EMAILS)
    const selectedTrustee = trustees[0]

    this.state = Object.assign({}, initialState, {trustees}, {selectedTrustee})
  }

  resetState() {
    this.setState(initialState)
  }

  setScreen(screen) {
    this.setState({ screen })
  }

  setThankYouScreen() {
    this.setScreen('thankYou')
  }
  
  setSelectedTrustee(trustee) {
    this.setState({selectedTrustee: trustee})
  }

  submitForm = (values, actions) => {
    this.setState({ loading: true })

    const { complianceStore } = this.props

    const payload = {
      trustee: this.state.selectedTrustee.id,
      type: this.state.selectedTrustee.type,
      message: values.message
    }
    
    try {
      complianceStore
        .sendAnonymousActionEmail(payload, this.setThankYouScreen)
        .catch(({ message }) => {
          this.setState({ error: message })
        }).finally(() => {
          actions.setSubmitting(false)
          this.setState({ loading: false })
        })
    } catch (error) {
      this.growlStore.showError(error)
    }
  }

  capitalizeName(name) {
    return name.charAt(0).toUpperCase() + name.slice(1)
  }

  render() {
    if (this.state.loading) {
      return <Loading />
    }

    const pageTitle = 'Anonymous action'

    const screens = {
      thankYou: (
        <ThankYou
          pageTitle={pageTitle}
          message="The information has been sent to the trustee"
          accept={() => this.resetState()}
        />
      )
    }

    if (this.state.screen) {
      return screens[this.state.screen]
    }

    return (
      <Formik
        initialValues={{
          message: ''
        }}
        onSubmit={this.submitForm}
        render={form => (
          <div className='expert-compliance'>
            <SidePanel />
            <div className='form-expert-compliance'>
              <Logo className='expert-compliance-form-logo' />
              <h1 className='form-expert-compliance__title'>{pageTitle}</h1>
              <div className='form-inner'>
                <h3 className='form-expert-compliance__title form-expert-compliance__subtitle'>
                  Welcome
                </h3>
                <Form onSubmit={form.handleSubmit} className="anonymous-action-form">
                  <Field
                    name='trustee'
                    label={'Please select type'}
                    itemToString={item => item && item.type}
                    options={this.state.trustees}
                    selectedItem={this.state.selectedTrustee}
                    onChange={trustee => this.setSelectedTrustee(trustee)}
                    component={Dropdown}
                  />
                  <Field
                    name='message'
                    label={'This information will be submitted to trustee anonymously unless you choose to include any personal information'}
                    component={TextArea}
                  />
                  <div className='expert-compliance-form-button-section'>
                    <Button
                      className='expert-compliance-form-button'
                      red
                      submit
                      onClick={this.onSubmit}
                      disabled={form.isSubmitting}
                    >
                      Send
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        )}
      />
    )
  }
}

const parseTrusteesFromEnvVar = ENV_VAR => {
  let trustees = []

  if (!!ENV_VAR) {
    trustees = ENV_VAR
      .replace('{', '')
      .replace('}', '')
      .split(',')
      .reduce((acc, string) => {
          const arr = string.split('=')
          const type = arr[0]
          const email = arr[1]
          if (type && email) {
              acc.push({
                type,
                id: email
              })
          }
          return acc
      }, [])

    // Add formatted type
    trustees = trustees.map(trustee => {
      let formattedType = trustee.type
      
      if (trustee.type !== 'HR') {
        formattedType = formattedType.toLowerCase()
        formattedType = formattedType.charAt(0).toUpperCase() + formattedType.slice(1)
      }

      formattedType += ' complaint' 

      trustee.type = formattedType
      return trustee
    })
  }

  return trustees
}

export default inject('complianceStore', 'growlStore')(observer(AnonymousAction))